/**
 * Base tenant links DTO
 */
export abstract class BaseTenantLinksDto {
	id!: number;
	locationId?: number | null;
	customerId?: number | null;
	supplierId?: number | null;
	agentId?: number | null;
	vehicleId?: number | null;
}
